import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { StateWithProduct } from '@spartacus/core';
import { GenProductActions } from '../features/product/store/actions';

@Injectable({
  providedIn: 'root',
})
export class GenProductStateService {
  constructor(private store: Store<StateWithProduct>) {}

  clearProductScope(): void {
    this.store.dispatch(new GenProductActions.CustomClearProductScope());
  }
}
